import { ActionContext, ActionTree, GetterTree } from "vuex";

const initialState: any = {
  env: null
};

const actions: ActionTree<any, any> = {
  setEnvironment({ commit }: ActionContext<any, any>, payload: any): void {
    commit("setEnvironment", payload);
  },
  clearState({ commit }: ActionContext<any, any>): void {
    commit("clearState");
  }
};

const mutations = {
  setEnvironment(state: any, payload: any) {
    state.env = payload;
  },
  clearState(state: any) {
    Object.assign(state, { ...initialState });
  }
};

const getters: GetterTree<any, any> = {
  environment(state: any) {
    return state.env;
  }
};

const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
